import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/partners/bigfish-logo.svg")